var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { convertToClientCountryData, convertToClientIndexTypeData, convertToClientPriorityData, convertToServerCountryData, convertToServerPriorityData, } from '@core';
import { convertToClientConstructionTypeEnumData, convertToServerConstructionTypeEnumData, } from './construction-type-enum.converter';
export var convertToClientConstructionTypesList = function (data) {
    return data.map(function (data) { return (__assign({}, data)); });
};
export var convertToServerConstructionsFilterData = function (data) { return ({
    name: data.name || null,
    shortName: data.constructionType || null,
    description: data.description || null,
    countryType: convertToServerCountryData(data.country) || null,
}); };
export var convertToClientConstructionsAddData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return ({
        id: (_a = data.id) !== null && _a !== void 0 ? _a : '',
        name: (_b = data.name) !== null && _b !== void 0 ? _b : '',
        description: (_c = data.description) !== null && _c !== void 0 ? _c : '',
        priority: (_d = convertToClientPriorityData(data.priority)) !== null && _d !== void 0 ? _d : '',
        descriptionSource: (_e = data.descriptionSource) !== null && _e !== void 0 ? _e : '',
        country: (_f = convertToClientCountryData(data.countries)) !== null && _f !== void 0 ? _f : [],
        maxHeight: (_g = String(data.maxHeight)) !== null && _g !== void 0 ? _g : '',
        fireResistance: (_h = String(data.fireResistance)) !== null && _h !== void 0 ? _h : '',
        propertySource: (_j = data.propertySource) !== null && _j !== void 0 ? _j : '',
        labRTotal: data.rTotal ? data.rTotal.join(', ') : '',
        labIndex: (_k = convertToClientIndexTypeData(data.index)) !== null && _k !== void 0 ? _k : '',
        labIndexValue: (_l = String(data.laboratoryIndexValue)) !== null && _l !== void 0 ? _l : '',
        constructionType: (_m = convertToClientConstructionTypeEnumData(data.constructionType)) !== null && _m !== void 0 ? _m : '',
        constructionTypeObject: (_o = convertToClientConstructionType(data.constructionType)) !== null && _o !== void 0 ? _o : '',
        laboratoryTestSource: (_p = data.laboratoryTestSource) !== null && _p !== void 0 ? _p : '',
        issuer: (_q = data.issuerId) !== null && _q !== void 0 ? _q : '',
        issuerName: (_s = (_r = data.issuer) === null || _r === void 0 ? void 0 : _r.name) !== null && _s !== void 0 ? _s : '',
    });
};
export var convertToClientConstructionsEditData = function (data) {
    var _a, _b, _c;
    return __assign(__assign({}, convertToClientConstructionsAddData(data)), { constructionType: (_a = data.constructionType.constructionTypeEnum) !== null && _a !== void 0 ? _a : '', RCalcs: (_b = String(data.rw)) !== null && _b !== void 0 ? _b : '', estimatedIndexValue: (_c = String(data.computingIndexValue)) !== null && _c !== void 0 ? _c : '' });
};
export var convertToServerConstructionType = function (data) {
    var _a;
    return ({
        constructionTypeEnum: convertToServerConstructionTypeEnumData(data.constructionTypeEnum),
        constructions: ((_a = data.constructions) === null || _a === void 0 ? void 0 : _a.map(function (construction) {
            var _a;
            return ({
                constructionPosition: construction.contructionPosition,
                userMaterials: ((_a = construction.userMaterials) === null || _a === void 0 ? void 0 : _a.map(function (userMaterial) {
                    var _a;
                    return ({
                        materialId: userMaterial.materialId,
                        positionId: +userMaterial.positionId,
                        materialTypeValue: ((_a = userMaterial.materialTypeValue) === null || _a === void 0 ? void 0 : _a.map(function (materialTypeValue) { return ({
                            value: +materialTypeValue.value,
                            materialParametrs: materialTypeValue.materialParameters,
                        }); })) || [],
                    });
                })) || [],
            });
        })) || [],
    });
};
export var convertToClientConstructionType = function (data) {
    var _a, _b;
    return ({
        constructionTypeEnum: (_a = convertToClientConstructionTypeEnumData(data.constructionTypeEnum)) !== null && _a !== void 0 ? _a : '',
        constructions: ((_b = data.constructions) === null || _b === void 0 ? void 0 : _b.map(function (construction) {
            var _a, _b;
            return ({
                contructionPosition: (_a = construction.constructionPosition) !== null && _a !== void 0 ? _a : '',
                userMaterials: ((_b = construction.userMaterials) === null || _b === void 0 ? void 0 : _b.map(function (userMaterial) {
                    var _a, _b, _c, _d;
                    return ({
                        materialId: (_a = userMaterial.materialId) !== null && _a !== void 0 ? _a : '',
                        positionId: String((_b = userMaterial.positionId) !== null && _b !== void 0 ? _b : ''),
                        materialType: (_c = userMaterial.materialType) !== null && _c !== void 0 ? _c : '',
                        materialTypeValue: ((_d = userMaterial.materialTypeValue) === null || _d === void 0 ? void 0 : _d.map(function (materialTypeValue) {
                            var _a, _b;
                            return ({
                                value: String((_a = materialTypeValue.value) !== null && _a !== void 0 ? _a : ''),
                                materialParameters: String((_b = materialTypeValue.materialParametrs) !== null && _b !== void 0 ? _b : ''),
                            });
                        })) || [],
                    });
                })) || [],
            });
        })) || [],
    });
};
export var convertToServerConstructionsAddData = function (data) { return ({
    name: data.name || null,
    description: data.description || null,
    priority: convertToServerPriorityData(data.priority) || null,
    descriptionSource: data.descriptionSource || null,
    countries: convertToServerCountryData(data.country) || null,
    issuerId: data.issuer || undefined,
    maxHeight: +data.maxHeight || undefined,
    fireResistance: data.fireResistance || null,
    propertySource: data.propertySource || null,
    rTotal: data.labRTotal.split(',').map(function (split) { return +split; }) || null,
    index: data.labIndex || null,
    indexValue: +data.labIndexValue || undefined,
    laboratoryTestSource: data.laboratoryTestSource || null,
    constructionType: convertToServerConstructionType(data.constructionTypeObject) || null,
}); };
export var convertToServerConstructionsEditData = function (data) { return (__assign(__assign({}, convertToServerConstructionsAddData(data)), { id: data.id || null, rw: data.RCalcs || null, conputingIndexValue: data.estimatedIndexValue || null })); };
